module.exports = {"Type":"ChoiceAction","Disabled":true,"Output":true,"Fields":[{"label":"Text","type":"multiline","name":"text","serializeTo":"q"},{"label":"Name of the variable","name":"name","serializeTo":"node"},{"label":"Image URL","name":"imageUrl"},{"label":"Show thumbnail?","type":"yesno","name":"thumbnail"},{"label":"Speak","name":"speak"}],"Header":{"Color":"white","BackgroundColor":"#2f83bd","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/ChoiceAction.json
// module id = 690
// module chunks = 0